/* eslint-disable camelcase */
import GetGiftCertificates from '../routes/GetGiftCertificates';

interface GiftCert {
    id: string;
    name: string;
    type: string;
}

/**
 * Transform the gift certificate data
 * @param {array} rawGiftCerts - Raw data regarding from the CMS
 * @returns GiftCert[] - Array of GiftCerts
 */

export const transformAndFetchGiftCertificates = async (rawGiftCerts: Record<string, any>[]) => {
    const transformedGiftCertificates: GiftCert[] = [];

    try {
        const response = await GetGiftCertificates();

        if (response.status === 200) {
            rawGiftCerts.forEach(rawGiftCert => {
                const giftCertId = rawGiftCert.gift_certificate[0];
                const selectedGiftCert = response.data.find(dbGiftCert => dbGiftCert?.id === giftCertId);

                if (selectedGiftCert) {
                    const transformedGiftCert: GiftCert = {
                        id: selectedGiftCert.id,
                        name: rawGiftCert.gift_certificate_display_name || selectedGiftCert.name,
                        type: selectedGiftCert.type,
                    };
                    transformedGiftCertificates.push(transformedGiftCert);
                }
            });
        } else {
            console.error('transformAndFetchGiftCertificates', response);
        }
    } catch (error) {
        console.error('transformAndFetchGiftCertificates', error);
    }

    return transformedGiftCertificates;
};